import { Navigate } from "react-router-dom";
import { Layout } from "../components/Layout";
import { CompetitionHubTab } from "../components/CompetitionHubTab";
import { useAuth } from "../contexts/AuthContext";

export default function CompetitionHub() {
	const { user } = useAuth();
	const isAdmin = user?.is_admin || user?.role === "admin";
	const isCoach = user?.role === "coach" || isAdmin;

	if (!isCoach) {
		return <Navigate to="/dashboard" replace />;
	}

	return (
		<Layout>
			<CompetitionHubTab />
		</Layout>
	);
}
